"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var react_toastify_1 = require("react-toastify");
var react_router_1 = require("react-router");
var store_1 = require("../../store/store");
var actions_1 = require("../../store/cart/actions");
var PaymentButton_1 = require("../../components/PaymentButton");
var reducer_1 = require("../../store/restaurant/reducer");
var network_1 = require("../../network");
var PaymentCard = function (_a) {
    var _b, _c;
    var createPaymentIntentRequest = _a.createPaymentIntentRequest, total = _a.total;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _d = (0, react_1.useState)(false), succeeded = _d[0], setSucceeded = _d[1];
    var _e = (0, react_1.useState)(''), error = _e[0], setError = _e[1];
    var _f = (0, react_1.useState)(false), processing = _f[0], setProcessing = _f[1];
    var _g = (0, react_1.useState)(true), disabled = _g[0], setDisabled = _g[1];
    var stripe = (0, react_stripe_js_1.useStripe)();
    var elements = (0, react_stripe_js_1.useElements)();
    var restaurantId = (0, react_router_1.useParams)().restaurant;
    var searchParams = new URLSearchParams(location.search);
    var type = searchParams.get('type') || '';
    var _h = (0, network_1.useGetRestaurant)({ id: restaurantId }).data, restaurant = _h === void 0 ? {} : _h;
    var _j = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return ({
            currency: (_a = state.app.chain) === null || _a === void 0 ? void 0 : _a.currency,
            pickupTime: state.cart.pickupTime,
            table: state.cart.table,
            loading: state.payment.loading,
        });
    }), currency = _j.currency, loading = _j.loading, pickupTime = _j.pickupTime, table = _j.table;
    var tableNumber = ((_b = restaurant.tables) === null || _b === void 0 ? void 0 : _b.length) ? ((_c = restaurant.tables.find(function (item) { return String(item.id) === table; })) === null || _c === void 0 ? void 0 : _c.number) || '' : table;
    var cardStyle = {
        style: {
            base: {
                color: '#808080',
                fontFamily: '"Poppins", -apple-system, BlinkMacSystemFont, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '13px',
                fontWeight: '500',
                '::placeholder': {
                    color: '#808080',
                },
                border: '1px solid #C4C4C4'
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a',
            },
        },
    };
    var handleChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setDisabled(event.empty);
            if (event.error) {
                react_toastify_1.toast.error(event.error.message);
            }
            return [2];
        });
    }); };
    var handleSubmit = function (ev) { return __awaiter(void 0, void 0, void 0, function () {
        var piData, payload, key, prevParams, newParams, URLParams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ev.preventDefault();
                    if (!pickupTime && type === reducer_1.RestaurantDeliveryType.Pickup) {
                        react_toastify_1.toast.error("Please, enter Pick-up Time");
                        return [2];
                    }
                    else if (!tableNumber && type === reducer_1.RestaurantDeliveryType.Dinein) {
                        react_toastify_1.toast.error("Please, enter table number");
                        return [2];
                    }
                    if (!elements) {
                        react_toastify_1.toast.error("Payment failed - no card");
                        setProcessing(false);
                        return [2];
                    }
                    setProcessing(true);
                    return [4, createPaymentIntentRequest()];
                case 1:
                    piData = _a.sent();
                    if (!piData.client_secret) {
                        react_toastify_1.toast.error(piData.e);
                        setProcessing(false);
                        return [2];
                    }
                    return [4, (stripe === null || stripe === void 0 ? void 0 : stripe.confirmCardPayment(piData.client_secret, {
                            payment_method: {
                                card: elements.getElement(react_stripe_js_1.CardElement),
                            },
                        }))];
                case 2:
                    payload = _a.sent();
                    key = piData.key;
                    if (!(payload === null || payload === void 0 ? void 0 : payload.error)) return [3, 3];
                    react_toastify_1.toast.error("Payment failed ".concat(payload.error.message));
                    setProcessing(false);
                    return [3, 5];
                case 3:
                    prevParams = Object.fromEntries(searchParams);
                    newParams = __assign(__assign({}, prevParams), { type: type, key: key });
                    URLParams = new URLSearchParams(newParams);
                    setProcessing(false);
                    setSucceeded(true);
                    dispatch((0, actions_1.cartClear)());
                    return [4, store_1.history.push({
                            pathname: "/store/".concat(restaurantId, "/confirm"),
                            search: URLParams.toString(),
                        })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [2];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("form", __assign({ id: "payment-form", onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(react_stripe_js_1.CardElement, { id: "card-element", className: "checkout-card-element", options: cardStyle, onChange: handleChange }), (0, jsx_runtime_1.jsx)(PaymentButton_1.PaymentButton, { isDisabled: processing || loading, total: total, currency: currency }), error && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "card-error", role: "alert" }, { children: error })))] })));
};
exports.PaymentCard = PaymentCard;
